import type { FunctionComponent, ReactNode } from 'react';
import { IPaymentsModal } from '../../../interfaces';
import {
  PM_CHILDREN,
  PM_CLOSE_CONTAINER,
  PM_CONTAINER,
  PM_CONTENT,
  PM_SUBTITLE,
  PM_TITLE,
} from './paymentsModalTestIds';
import WarningBanner from './WarningBanner';
import closeButton from '../assets/close.png';
import * as styles from './PaymentModal.module.css';

const PaymentsModal: FunctionComponent<IPaymentsModal> = ({
  isOpen,
  onClose = () => null,
  hasError = false,
  title = '',
  subtitle = '',
  children,
}): ReactNode | null =>
  isOpen ? (
    <div data-testid={PM_CONTAINER} className={styles.pmContainer}>
      <div data-testid={PM_CONTENT} className={styles.content}>
        <div
          data-testid={PM_CLOSE_CONTAINER}
          className={styles.close}
          onClick={onClose}
          onKeyPress={onClose}
          tabIndex={0}
          role="button"
          aria-label="Close this window"
        >
          <img src={closeButton} alt="close" />
        </div>
        <div data-testid={PM_TITLE} className={styles.pmTitle}>
          {title}
        </div>
        <div data-testid={PM_SUBTITLE} className={styles.pmSubtitle}>
          {subtitle}
        </div>
        {hasError && <WarningBanner />}
        <div data-testid={PM_CHILDREN} className={styles.content}>
          {children}
        </div>
      </div>
    </div>
  ) : null;

export default PaymentsModal;
